<h1 mat-dialog-title> Crear Proveedor </h1> <br/>

<form #proveedorForm=ngForm>

    <mat-dialog-content>

        <p>
            <mat-label>
                <h2> Proveedor </h2>
            </mat-label>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> RUT </mat-label>

                <input name="rut" matInput [(ngModel)]="proveedor.rut" required placeholder="Formato: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" #rut="ngModel" />

            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Nombre Corto </mat-label>

                <input name="nombreCorto" id="nombreCorto" matInput required [(ngModel)]="proveedor.nombreCorto" #nombreCorto="ngModel" (ngModelChange)="proveedor.nombreCorto = $event.toUpperCase()" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Nombre Proveedor </mat-label>

                <input name="nombreProveedor" id="nombreProveedor" matInput required [(ngModel)]="proveedor.nombreProveedor" (ngModelChange)="proveedor.nombreProveedor = $event.toUpperCase()" #nombreProveedor="ngModel" />

            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Código de Finanzas </mat-label>

                <input name="codigoFin" id="codigoFin" matInput required [(ngModel)]="proveedor.codigoFin" (ngModelChange)="proveedor.codigoFin = $event.toUpperCase()" #codigoFin="ngModel" />

            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Dirección </mat-label>

                <input name="direccion" id="direccion" matInput required [(ngModel)]="proveedor.direccion" #direccion="ngModel" (ngModelChange)="proveedor.direccion = $event.toUpperCase()" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Región </mat-label>
                <mat-select name="idRegion" id="idRegion" #idRegion="ngModel" [(ngModel)]="proveedor.idRegion" required (selectionChange)="cargaComunas(proveedor.idRegion)">
                    <mat-option value=0>

                        SELECCIONE....

                    </mat-option>
                    <mat-option *ngFor="let r of this.regiones" value="{{r.id}}">

                        {{r.nombre}}

                    </mat-option>
                </mat-select>




            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Comuna</mat-label>

                <mat-select name="idComuna" id="idComuna" [(ngModel)]="proveedor.idComuna" #idComuna="ngModel">

                    <mat-option>

                        SELECCIONE....

                    </mat-option>
                    <mat-option *ngFor="let c of this.comunas" value="{{c.id}}">

                        {{c.nombre}}

                    </mat-option>
                </mat-select>
            </mat-form-field>
        </p>


        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Categoría</mat-label>

                <mat-select name="idCategoria" id="idCategoria" [(ngModel)]="proveedor.idCategoria" #idCategoria="ngModel">

                    <mat-option>

                        SELECCIONE....

                    </mat-option>
                    <mat-option *ngFor="let c of this.categorias" value="{{c.id}}">

                        {{c.descripcion}}

                    </mat-option>
                </mat-select>

            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Mínimo Cuotas</mat-label>

                <mat-select name="minCuotas" id="minCuotas" [(ngModel)]="proveedor.minCuotas" #minCuotas="ngModel">

                    <mat-option>

                        SELECCIONE....

                    </mat-option>
                    <mat-option *ngFor="let c of this.cuotas" value="{{c.id}}">

                        {{c.descripcion}}

                    </mat-option>
                </mat-select>


            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Máximo Cuotas</mat-label>

                <mat-select name="idCuotas" id="idCuotas" [(ngModel)]="proveedor.idCuotas" #idCuotas="ngModel">

                    <mat-option>

                        SELECCIONE....

                    </mat-option>
                    <mat-option *ngFor="let c of this.cuotas" value="{{c.id}}">

                        {{c.descripcion}}

                    </mat-option>
                </mat-select>


            </mat-form-field>
        </p>



    </mat-dialog-content> <br/>
</form>
<mat-dialog-actions>
    <button mat-button class="mat-raised-button btn-success" (click)="onCrearProveedorClick(proveedorForm)"> 
            <i class = "fa fa-plus"> </i> Crear
        </button>

    <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()"> 
            <i class = "fa fa-trash"> </i> Salir
        </button>

</mat-dialog-actions>

<br/>